import { Component, input, model, output, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { TextareaModule } from "primeng/textarea";

@Component({
  selector: "app-partner-request-model",
  standalone: true,
  imports: [FormsModule, DialogModule, ButtonModule, TextareaModule],
  templateUrl: "./partner-request-model.component.html",
  styleUrl: "./partner-request-model.component.css",
})
export class PartnerRequestModelComponent {
  visible = model<boolean>();
  type = input.required<"Accept" | "Reject">();

  message = output<string>();
  onClose = output();

  messageText = signal("");

  ngOnInit() {
    this.messageText.set("");
  }

  close() {
    this.onClose.emit();
  }

  sendResponse() {
    this.message.emit(this.messageText());
  }
}
